interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

export function setPageSeo({ title, description, keywords }: SeoOptions) {
  document.title = title;

  const setMeta = (name: string, content: string) => {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  if (description) setMeta("description", description);
  if (keywords) setMeta("keywords", keywords);
}